<template>
<div class="workflow-child">
    <div class="report-image-grid">
        <div class="card-grid-item">
                <h3  class="search-listing-title">
                    <a class="search-candidate-title"><i class="search-listing-icon fa fa-cloud"></i> <span>  Nuvola di Punti</span></a>
                </h3>
                <div class="search-listing-body">
                    <p>Seleziona se vuoi effettuare segnalazione direttamente su una nuvola di punti</p>
                </div>
                <div class="search-listing-footer">
                    
                    <a class="search-candidate-link pull-right"  @click="$emit('report-event',{'topic':'report-type-selected','report_type':'on-cloud'})"><i class="fa fa-check-circle"></i>  Seleziona</a>

                </div>

        </div>
        <div class="card-grid-item">
            <h3  class="search-listing-title">
                <a class="search-candidate-title"><i class="search-listing-icon fa fa-bookmark"></i> <span>  Compila Scheda</span></a>
            </h3>
            <div class="search-listing-body">
                <p>Seleziona per compilare direttamente la scheda</p>
            </div>
            <div class="search-listing-footer">
                
                <a class="search-candidate-link pull-right" @click="$emit($emit('report-event',{'topic':'report-type-selected','report_type':'on-card'}))"><i class="fa fa-check-circle"></i>  Seleziona</a>

            </div>

        </div>
    </div>
</div>
</template>

<script>
export default {
    name: 'ReportTypeSelect'
}
</script>

<style scoped>
    .panel {
        width: 240px;
    }
    .panel-body {
        font-size: 12px;
        text-align: left;
        overflow: hidden;
        width: 240px;
        height: 80px;
        white-space: wrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .container {
        float: left;
    }

    .panel-heading {
        color: darkcyan;
        text-align: left;
        font-size: 16px;
    }

</style>